/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { TuteurHistoryGridDto } from './TuteurHistoryGridDto';
import {
    TuteurHistoryGridDtoFromJSON,
    TuteurHistoryGridDtoFromJSONTyped,
    TuteurHistoryGridDtoToJSON,
} from './TuteurHistoryGridDto';

/**
 * 
 * @export
 * @interface TuteurHistoryGridDtoPaginatedResults
 */
export interface TuteurHistoryGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof TuteurHistoryGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<TuteurHistoryGridDto>}
     * @memberof TuteurHistoryGridDtoPaginatedResults
     */
    results?: Array<TuteurHistoryGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof TuteurHistoryGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the TuteurHistoryGridDtoPaginatedResults interface.
 */
export function instanceOfTuteurHistoryGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurHistoryGridDtoPaginatedResultsFromJSON(json: any): TuteurHistoryGridDtoPaginatedResults {
    return TuteurHistoryGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function TuteurHistoryGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurHistoryGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(TuteurHistoryGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function TuteurHistoryGridDtoPaginatedResultsToJSON(value?: TuteurHistoryGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(TuteurHistoryGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

